<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<form [formGroup]="contactForm" (ngSubmit)="submit()" class="new-message-sign-up">
  <div class="header">
    <p header>
      {{ 'INBOX.ADD_CONTACT.ADD_CONTACT_FORM_HEADER' | translate : { businessName: companyName$ | async } }}
    </p>

    <mat-icon class="close" mat-flat-button (click)="close()" close>close</mat-icon>
  </div>
  <glxy-form-row>
    <glxy-form-field class="col-xs-12 col-sm-6">
      <glxy-label>{{ 'INBOX.NEW_MESSAGE.FIRST_NAME' | translate }}</glxy-label>
      <input matInput formControlName="firstName" #firstNameInput autofocus />
      <glxy-error *ngIf="contactForm.controls.firstName.hasError('required') && contactForm.controls.firstName.touched">
        {{ 'INBOX.ERROR.REQUIRED_FIELD' | translate }}
      </glxy-error>
      <glxy-error *ngIf="contactForm.controls.firstName.hasError('minlength')">
        {{ 'INBOX.ERROR.INVALID_LENGTH_TOO_FEW_CHARACTERS' | translate : { min: MIN_CHARACTERS } }}
      </glxy-error>
    </glxy-form-field>
    <glxy-form-field class="col-xs-12 col-sm-6">
      <glxy-label>{{ 'INBOX.NEW_MESSAGE.LAST_NAME' | translate }}</glxy-label>
      <input matInput id="add-contact-form__last-name" formControlName="lastName" />
    </glxy-form-field>
  </glxy-form-row>
  <glxy-phone-input
    class="phone item"
    label="{{ 'INBOX.NEW_MESSAGE.PHONE' | translate }}"
    [useGalaxyFormField]="true"
    [required]="false"
    [formControl]="contactForm.controls.phone"
    #phoneInput
  ></glxy-phone-input>
  <glxy-form-field>
    <glxy-label>{{ 'INBOX.NEW_MESSAGE.EMAIL' | translate }}</glxy-label>
    <input matInput id="add-contact-form__email" formControlName="email" />
    <glxy-error *ngIf="contactForm.controls.email.invalid">
      {{ 'INBOX.ERROR.INVALID_EMAIL_ADDRESS' | translate }}
    </glxy-error>
  </glxy-form-field>
  <div class="accept-button">
    <button
      mat-flat-button
      color="primary"
      [disabled]="isSubmitted && (isLoading || contactForm.invalid)"
      data-action="clicked-add-contact"
    >
      {{ 'INBOX.NEW_MESSAGE.ADD_CONTACT' | translate }}
    </button>
  </div>
</form>
